<template>
  <!-- P2 (SPEC_VENTAS_INNOMINADAS_FACTURACION_DIFERIDA_v0.1.md RN-VI1, RN-VI2
       revisada el 2026-10-12): con la operativa de ticket activa se ve
       siempre. Innominado → Ticket por defecto; con documento → Factura, y el
       ticket no se puede elegir. Sin la operativa no se muestra: siempre factura. -->
  <div v-if="habilitado" class="selector-comprobante mb-3">
    <div class="text-muted small mb-1">Comprobante</div>
    <div class="btn-group w-100" role="group" aria-label="Comprobante">
      <button
        type="button"
        class="btn"
        :class="modelValue === COMPROBANTES.FACTURA ? 'btn-primary' : 'btn-outline-primary'"
        @click="elegir(COMPROBANTES.FACTURA)"
      >
        <i class="bi bi-receipt me-1"></i>Factura electrónica
      </button>
      <button
        type="button"
        class="btn"
        :class="modelValue === COMPROBANTES.TICKET ? 'btn-primary' : 'btn-outline-primary'"
        :disabled="!innominado"
        :title="innominado ? '' : 'El ticket es sólo para el cliente innominado'"
        @click="elegir(COMPROBANTES.TICKET)"
      >
        <i class="bi bi-ticket-perforated me-1"></i>Ticket
      </button>
    </div>
    <div v-if="!innominado" class="form-text">
      El cliente tiene documento: se emite factura. El ticket es sólo para el cliente innominado (X, 0 o S/D).
    </div>
    <div v-else-if="modelValue === COMPROBANTES.TICKET" class="form-text">
      Se entrega un ticket sin valor fiscal. La venta queda pendiente de factura y se factura en el sistema externo.
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted, onBeforeUnmount } from 'vue'
import operationalConfigService from '@/services/operationalConfigService'
import { COMPROBANTES, esDocumentoInnominado, comprobantePorDefecto } from '@/utils/comprobanteCobro.mjs'

/* global defineProps, defineEmits */
const props = defineProps({
  modelValue: { type: String, default: COMPROBANTES.FACTURA },
  documento: { type: String, default: '' }
})
const emit = defineEmits(['update:modelValue'])

const habilitado = ref(false)
const leerConfig = () => {
  habilitado.value = operationalConfigService.getConfig().ventas_innominadas_ticket_habilitado === true
}

const innominado = computed(() => esDocumentoInnominado(props.documento))

const elegir = (valor) => emit('update:modelValue', valor)

// El valor por defecto se aplica al abrir el cobro y cada vez que cambia el
// cliente o la operativa; después el cajero puede cambiarlo.
const aplicarPorDefecto = () => {
  const valor = comprobantePorDefecto({ documento: props.documento, habilitado: habilitado.value })
  if (valor !== props.modelValue) emit('update:modelValue', valor)
}
watch([() => props.documento, habilitado], aplicarPorDefecto)

onMounted(() => {
  leerConfig()
  aplicarPorDefecto()
  window.addEventListener('app:operational-config-changed', leerConfig)
  // Por si la caché local está vieja (otra pestaña o el servidor la cambió).
  operationalConfigService.loadConfig().then((config) => {
    habilitado.value = config?.ventas_innominadas_ticket_habilitado === true
  }).catch(() => {})
})
onBeforeUnmount(() => window.removeEventListener('app:operational-config-changed', leerConfig))
</script>
